module.exports = __webpack_public_path__ + "media/images/front/sp/treatment-introduction-article/img02-afde79ace0e72e49410705b203783c26.png";